import init from './thing'

const disease =
{
    ...init
};

export default disease ;
